import { render, staticRenderFns } from "./primaryMenuManage.vue?vue&type=template&id=1efbfcc4&scoped=true"
import script from "./primaryMenuManage.vue?vue&type=script&lang=js"
export * from "./primaryMenuManage.vue?vue&type=script&lang=js"
import style0 from "./primaryMenuManage.vue?vue&type=style&index=0&id=1efbfcc4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbfcc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efbfcc4')) {
      api.createRecord('1efbfcc4', component.options)
    } else {
      api.reload('1efbfcc4', component.options)
    }
    module.hot.accept("./primaryMenuManage.vue?vue&type=template&id=1efbfcc4&scoped=true", function () {
      api.rerender('1efbfcc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/dishGroupManage/primaryMenuManage.vue"
export default component.exports